import React from "react";
import { withRouter } from "react-router-dom";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import ObjectOverride from "components/ObjectOverride";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";

//export default class MarketingBanner extends ObjectOverride {
class MarketingBanner extends React.Component{
	constructor(props) {
		super(props);
		this.navigateToHome = this.navigateToHome.bind(this);
	}

	// componentDidUpdate(prevProps, prevState, snapshot) {
	// 	super.componentDidUpdate(prevProps, prevState, snapshot);
	//
	// 	/** @type {Events_Object} object */
	// 	let object = this.state;
	//
	// 	if (typeof this.props.updateName === 'function') {
	// 		this.props.updateName(object.name);
	// 	}
	// }
	//
	//
	// handleSubmit = () => {
	// 	let d1 = new Date(this.state.start);
	// 	let d2 = new Date(this.state.end);
	// 	if(d1 > d2) {
	// 		this.setState({date_error: true})
	// 	}
	// 	else {
	// 		super.handleSubmit();
	// 	}
	// }


		// async afterSubmit(data, request, suppressProcess = false) {
		// 	if (typeof this.props.setNewObject === 'function') {
		// 		this.props.setNewObject(data);
		// 	}
		// };


	// ignoreWarning = (warningName) => () => {
	// 	this.setState({
	// 		[warningName]: false
	// 	});
	// };

	navigateToHome() {
		this.props.history.push('/');
	}


	render() {
		// /** @type {Events_Properties} properties */
		// let properties = this.model.properties;
		// /** @type {Events_Object} object */
		// let object = this.state;
		// let {loading} = this.state;

		return (
			<div style={{display: 'flex', backgroundColor: 'blue', padding: 15, fontSize: 25, justifyContent: 'center', color: 'white', cursor: 'pointer'}}
			     onClick={this.navigateToHome}>
				Marketing Banner Message
			</div>
		)
	};
}

export default withRouter(MarketingBanner);
